// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"396":"41155975","691":"component---src-pages-index-tsx"}[chunkId] || chunkId) + "-" + {"396":"54da48480d687aa7e242","691":"3ebcdf1d2a03163faef7","731":"cf4f83dca2551eab5fcd","843":"35e467e1ad8dcb13e557"}[chunkId] + ".js";
};